const luggage_lost = `വിഷയം: ലഗേജ് നഷ്ടപ്പെട്ട പരാതി
പ്രിയ ഫിന്നായർ കസ്റ്റമർ സർവീസ്,
അടുത്തിടെ ഫിൻഎയറുമായുള്ള യാത്രയ്ക്കിടെ എന്റെ ലഗേജ് നഷ്ടപ്പെട്ട വിവരം അറിയിക്കാനാണ് ഞാൻ എഴുതുന്നത്.
എന്റെ ബാഗേജുകൾ എന്നോടൊപ്പം ലക്ഷ്യസ്ഥാനത്ത് എത്തിയിട്ടില്ല, ഇത് എനിക്ക് വളരെയധികം അസൗകര്യങ്ങൾ സൃഷ്ടിച്ചു.
എന്റെ ലഗേജ് കണ്ടെത്തുന്നതിനും അത് എനിക്ക് പെട്ടെന്ന് ഡെലിവറി ചെയ്യുന്നതിനും നിങ്ങളുടെ അടിയന്തിര സഹായത്തെ ഞാൻ അഭിനന്ദിക്കുന്നു.
ലഗേജിലെ ഉള്ളടക്കങ്ങൾ എനിക്ക് പ്രധാനമാണ്, അവ എത്രയും വേഗം തിരികെ ലഭിക്കാൻ ഞാൻ ഉത്സുകനാണ്.
എന്റെ ബാഗേജിന്റെ സ്റ്റാറ്റസ് സംബന്ധിച്ച എന്തെങ്കിലും അപ്‌ഡേറ്റുകൾ എന്നെ അറിയിക്കാനും അത് ഡെലിവറി ചെയ്യുന്നതിനുള്ള ഒരു ടൈംലൈൻ നൽകാനും ഞാൻ ദയയോടെ അഭ്യർത്ഥിക്കുന്നു.
ഈ പ്രശ്നം വേഗത്തിലും കാര്യക്ഷമമായും പരിഹരിക്കുന്നതിന് ആവശ്യമായ നടപടികൾ ഫിന്നായർ സ്വീകരിക്കുമെന്ന് ഞാൻ വിശ്വസിക്കുന്നു.
ഈ വിഷയത്തിൽ നിങ്ങളുടെ പെട്ടെന്നുള്ള ശ്രദ്ധയ്ക്ക് നന്ദി.
ആത്മാർത്ഥതയോടെ,`;

export default luggage_lost;



















